import React from "react";
import { CircularProgress } from "@mui/material";
import {
  RequirementGeneralFields,
  RequirementOptionalFields,
  RequirementScianFields,
} from "./RequirementCreationFields.jsx";
import styles from "./index.module.css";

const RequirementCreationDialog = ({
  t,
  open,
  onClose,
  categories,
  sectors,
  originalCertifications,
  dialogRef,
  imageRef,
  requirement,
  subcategories,
  subSectors,
  branches,
  tempImage,
  imageError,
  isSubmitting,
  areMandatoryFieldsComplete,
  hasErrors,
  getErrorMessage,
  getFieldValidationState,
  selectCategoryRef,
  selectSubcategoryRef,
  selectSectorRef,
  selectSubsectorRef,
  selectBranchRef,
  onDragEnter,
  onDragLeave,
  onDrop,
  handleChangeImage,
  handleSubmitRequirement,
  handleTitleChange,
  handleDescriptionChange,
  handleLocationChange,
  handleVolumeChange,
  handleDueDateChange,
  handleExperienceChange,
  handleCategoryChange,
  handleSubcategoryChange,
  handleSectorChange,
  handleSubsectorChange,
  handleBranchChange,
  handleAddCertification,
  handleSelectCertification,
  handleDeleteCertification,
}) => (
  <>
    {open && <div className={styles.overlay}></div>}
    <dialog ref={dialogRef} className={styles.modal}>
      <div className={styles.closeButtonContainer}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
      </div>

      <div className={styles.modalContent}>
        <label className={styles.modalTitle}>
          {t("components.requirementCreationModal.header")}
        </label>
        <RequirementGeneralFields
          t={t}
          requirement={requirement}
          categories={categories}
          subcategories={subcategories}
          selectCategoryRef={selectCategoryRef}
          selectSubcategoryRef={selectSubcategoryRef}
          onCategoryChange={handleCategoryChange}
          onSubcategoryChange={handleSubcategoryChange}
          onTitleChange={handleTitleChange}
          onDueDateChange={handleDueDateChange}
          onDescriptionChange={handleDescriptionChange}
          onLocationChange={handleLocationChange}
          onExperienceChange={handleExperienceChange}
          getErrorMessage={getErrorMessage}
          getFieldValidationState={getFieldValidationState}
        />
        <RequirementScianFields
          t={t}
          sectors={sectors}
          subSectors={subSectors}
          branches={branches}
          requirement={requirement}
          selectSectorRef={selectSectorRef}
          selectSubsectorRef={selectSubsectorRef}
          selectBranchRef={selectBranchRef}
          onSectorChange={handleSectorChange}
          onSubsectorChange={handleSubsectorChange}
          onBranchChange={handleBranchChange}
        />
        <RequirementOptionalFields
          t={t}
          requirement={requirement}
          originalCertifications={originalCertifications}
          onAddCertification={handleAddCertification}
          onSelectCertification={handleSelectCertification}
          onDeleteCertification={handleDeleteCertification}
          imageRef={imageRef}
          onDragEnter={onDragEnter}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
          tempImage={tempImage}
          imageError={imageError}
          onImageChange={handleChangeImage}
          onVolumeChange={handleVolumeChange}
          getErrorMessage={getErrorMessage}
          getFieldValidationState={getFieldValidationState}
        />
      </div>

      <div className={styles.modalButtons}>
        <button
          className={styles.cancelButton}
          onClick={onClose}
          disabled={isSubmitting}
        >
          {t("components.requirementCreationModal.cancel")}
        </button>
        <button
          className={styles.createButton}
          onClick={handleSubmitRequirement}
          disabled={!areMandatoryFieldsComplete || hasErrors || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <CircularProgress size={20} color="inherit" />
              <span>{t("components.requirementCreationModal.sending")}</span>
            </>
          ) : (
            <>{t("components.requirementCreationModal.createRequirement")}</>
          )}
        </button>
      </div>
    </dialog>
  </>
);

export default RequirementCreationDialog;
